export default "__VITE_ASSET__DlcNsWKw__"